import { CartUpdateEvent } from '@theme/events';

/**
 * Subscribe / one-time toggle on cart lines.
 *
 * The control is INJECTED client-side (cart-products.liquid — this theme's largest custom
 * file — won't reliably sync new markup through the GitHub connection, so we don't depend
 * on it). For every cart line whose product has a Subscribe & Save plan we add:
 *   - "Subscribe & save 50%"  -> set the line's selling_plan to the monthly plan
 *   - a frequency <select>     -> Every Month / 2 / 3 Months
 *   - "Switch to one-time"     -> remove the selling plan
 * Each change hits /cart/change.js (verified: convert / change frequency / remove all work)
 * and morphs the cart via CartUpdateEvent. Runs on load + every cart:update (survives morphs).
 */
(function () {
  'use strict';

  var ROOT = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids[c.dataset.sectionId] = 1;
    });
    return Object.keys(ids).join(',');
  }

  /* ---------- styles (injected once) ---------- */
  (function () {
    if (document.getElementById('dgt-sub-style')) return;
    var s = document.createElement('style');
    s.id = 'dgt-sub-style';
    s.textContent =
      '.dgt-sub{margin-top:7px}' +
      '.dgt-sub__toggle{display:inline-flex;align-items:center;gap:5px;border:1.5px solid #e0551b;background:rgba(224,85,27,.08);color:#c0431a;border-radius:999px;padding:4px 12px;font-size:.8rem;font-weight:700;cursor:pointer}' +
      '.dgt-sub__toggle:hover{background:#e0551b;color:#fff}' +
      '.dgt-sub__on{display:none;flex-wrap:wrap;align-items:center;gap:5px 10px}' +
      '.dgt-sub.is-on .dgt-sub__toggle{display:none}' +
      '.dgt-sub.is-on .dgt-sub__on{display:flex}' +
      '.dgt-sub__badge{font-size:.8rem;font-weight:700;color:#256b48;white-space:nowrap}' +
      '.dgt-sub__freq-wrap{font-size:.78rem;display:inline-flex;align-items:center;gap:5px;opacity:.9}' +
      '.dgt-sub__freq{font-size:.78rem;padding:3px 6px;border:1px solid rgba(0,0,0,.18);border-radius:7px;background:inherit;color:inherit}' +
      '.dgt-sub__off{background:none;border:0;padding:0;font-size:.76rem;text-decoration:underline;opacity:.65;cursor:pointer}' +
      '.dgt-sub__off:hover{opacity:1}' +
      '.dgt-sub.is-busy{opacity:.5;pointer-events:none}';
    (document.head || document.documentElement).appendChild(s);
  })();

  /* ---------- change the line's selling plan ---------- */
  var busy = false;
  function change(lineKey, plan, wrap) {
    if (busy || !lineKey) return;
    busy = true;
    if (wrap) wrap.classList.add('is-busy');
    // Look up the line's current quantity first — changing selling_plan via /cart/change.js
    // otherwise resets the line to quantity 1.
    fetch(ROOT() + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (i) { return i.key === lineKey; })[0];
        var qty = line ? line.quantity : 1;
        var body = {
          id: lineKey,
          quantity: qty,
          selling_plan: plan ? plan : '', // '' removes the plan (one-time)
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        };
        return fetch(ROOT() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CartUpdateEvent(data, '', { source: 'dgt-subscribe-toggle', sections: data.sections }));
      })
      .catch(function (e) { console.error('[dgt-subscribe-toggle] change failed', e); })
      .finally(function () { busy = false; if (wrap) wrap.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sub = t.closest('[data-sub-subscribe]');
    if (sub) { e.preventDefault(); var w = sub.closest('[data-sub]'); change(w && w.getAttribute('data-line-key'), sub.getAttribute('data-plan'), w); return; }
    var off = t.closest('[data-sub-onetime]');
    if (off) { e.preventDefault(); var w2 = off.closest('[data-sub]'); change(w2 && w2.getAttribute('data-line-key'), '', w2); }
  });

  document.addEventListener('change', function (e) {
    var freq = e.target && e.target.closest ? e.target.closest('[data-sub-freq]') : null;
    if (!freq) return;
    var w = freq.closest('[data-sub]');
    change(w && w.getAttribute('data-line-key'), freq.value, w);
  });

  /* ---------- inject the control onto each subscribable cart line ---------- */
  var FREQ_ORDER = ['Every Month', 'Every 2 Months', 'Every 3 Months'];
  var planCache = {};
  function getPlans(handle) {
    if (!handle) return Promise.resolve({ plans: [], monthly: null });
    if (planCache[handle]) return Promise.resolve(planCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var plans = [];
        (p.selling_plan_groups || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (sp) { plans.push({ id: sp.id, name: sp.name }); });
        });
        plans.sort(function (a, b) {
          var ia = FREQ_ORDER.indexOf(a.name), ib = FREQ_ORDER.indexOf(b.name);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        });
        var monthly = (plans.filter(function (x) { return x.name === 'Every Month'; })[0] || plans[0] || {}).id;
        planCache[handle] = { plans: plans, monthly: monthly };
        return planCache[handle];
      })
      .catch(function () { planCache[handle] = { plans: [], monthly: null }; return planCache[handle]; });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function needsInject() {
    var rows = document.querySelectorAll('[data-key]');
    for (var i = 0; i < rows.length; i++) { if (!rows[i].hasAttribute('data-sub-checked')) return true; }
    return false;
  }

  var injecting = false;
  function injectControls() {
    if (injecting || !needsInject()) return;
    injecting = true;
    fetch(ROOT() + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        (cart.items || []).forEach(function (it) { byKey[it.key] = it; });
        var rows = Array.prototype.slice.call(document.querySelectorAll('[data-key]'));
        var tasks = rows.map(function (row) {
          if (row.hasAttribute('data-sub-checked')) return null;
          var key = row.getAttribute('data-key');
          var it = byKey[key];
          if (!it) return null;
          row.setAttribute('data-sub-checked', '1');
          if (it.product_type === 'Free Gift' || (it.properties && it.properties._gift)) return null;
          return getPlans(it.handle).then(function (pc) {
            if (!pc.plans.length || row.querySelector('[data-sub]')) return;
            var curPlan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : null;
            var opts = pc.plans.map(function (pl) {
              var sel = (pl.id === curPlan) || (!curPlan && pl.id === pc.monthly);
              return '<option value="' + pl.id + '"' + (sel ? ' selected' : '') + '>' + esc(pl.name) + '</option>';
            }).join('');
            var wrap = document.createElement('div');
            wrap.className = 'dgt-sub' + (curPlan ? ' is-on' : '');
            wrap.setAttribute('data-sub', '');
            wrap.setAttribute('data-line-key', key);
            wrap.innerHTML =
              '<button type="button" class="dgt-sub__toggle" data-sub-subscribe data-plan="' + pc.monthly + '">🔁 Subscribe &amp; save 50%</button>' +
              '<div class="dgt-sub__on"><span class="dgt-sub__badge">✓ Subscribed · 50% off</span>' +
              '<label class="dgt-sub__freq-wrap">Deliver <select class="dgt-sub__freq" data-sub-freq aria-label="Delivery frequency">' + opts + '</select></label>' +
              '<button type="button" class="dgt-sub__off" data-sub-onetime>Switch to one-time</button></div>';
            var cell = row.querySelector('.cart-items__details') || row;
            cell.appendChild(wrap);
          });
        });
        return Promise.all(tasks);
      })
      .catch(function (e) { console.error('[dgt-subscribe-toggle] inject failed', e); })
      .finally(function () { injecting = false; });
  }

  document.addEventListener('cart:update', function () { setTimeout(injectControls, 80); });
  // A cart morph replaces the rows (dropping data-sub-checked); re-inject when new rows appear.
  var mo = new MutationObserver(function () { if (needsInject()) setTimeout(injectControls, 60); });
  function boot() {
    injectControls();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
